var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("editor", {
    attrs: {
      "api-key": _vm.apiKey,
      value: _vm.value,
      init: _vm.tinyMceInit,
      name: _vm.name
    },
    on: { input: _vm.input, onRemove: _vm.remove }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }